import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const GOOGLE_INTEGRATION_NAME = 'google';
export const ZGoogleIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(GOOGLE_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=google.js.map